export enum ContractSecurityLevel {
	EXTENDED = 'EXTENDED',
	DEFAULT_SECURITY_LEVEL = 'USUAL'
}
